import * as React from 'react';

import { cn } from '@/lib/cn';

import { ScrollArea, type ScrollAreaProps } from './scroll-area';

export interface VerticalOverflowScrollAreaProps
  extends Omit<ScrollAreaProps, 'orientation' | 'scrollbarInset' | 'scrollbarThickness'> {
  scrollbarInset?: number;
  scrollbarThickness?: number;
}

const DEFAULT_SCROLLBAR_THICKNESS = 5;
const DEFAULT_SCROLLBAR_INSET = 1;

/**
 * Thin persistent vertical scroll affordance for bounded-height regions.
 * Keeps the API narrow and centralizes the repo-default thumb sizing.
 */
export const VerticalOverflowScrollArea = React.forwardRef<HTMLDivElement, VerticalOverflowScrollAreaProps>(
  (
    {
      className,
      contentClassName,
      scrollbarInset = DEFAULT_SCROLLBAR_INSET,
      scrollbarThickness = DEFAULT_SCROLLBAR_THICKNESS,
      ...props
    },
    ref,
  ) => (
    <ScrollArea
      ref={ref}
      className={className}
      contentClassName={cn('pr-3', contentClassName)}
      orientation="vertical"
      scrollbarInset={scrollbarInset}
      scrollbarThickness={scrollbarThickness}
      {...props}
    />
  ),
);

VerticalOverflowScrollArea.displayName = 'VerticalOverflowScrollArea';
